import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import store, { history } from './store-index';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-select/dist/react-select.css';

// eslint-disable-next-line
import registerServiceWorker, { unregister } from './registerServiceWorker';
import AppContainer from './containers/App/AppContainer';

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <AppContainer />
        </ConnectedRouter>
    </Provider>, document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js